import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { NOTIFICATION_TYPES } from '../../../../constants';
import { useEmailDecisionMakerModal } from '../useEmailDecisionMakerModal';

type Props = {
	onDismiss?: () => void;
};

type UseEmailDecisionMakerNotificationReturn = ModelHookResult<
	{ isModalOpen: boolean },
	{ handleClick: () => void; handleDismiss: () => void; closeModal: () => void }
>;

export function useEmailDecisionMakerNotification({ onDismiss }: Props = {}): UseEmailDecisionMakerNotificationReturn {
	const track = useTracking();
	const { isOpen, openModal, closeModal } = useEmailDecisionMakerModal();

	const handleClick = useCallback(() => {
		void track('petition_manage_notification_cta_click', {
			notification: NOTIFICATION_TYPES.emailDecisionMaker,
		});

		openModal();
	}, [track, openModal]);

	const handleDismiss = useCallback(() => {
		onDismiss?.();
	}, [onDismiss]);

	return {
		data: { isModalOpen: isOpen },
		actions: { handleClick, handleDismiss, closeModal },
	};
}
